import { Component } from '@angular/core';
import { ProjectScenarioWholesaleDataGridService } from './project-scenario-wholesale-data-grid.service';
import {
  ProjectsFacade,
  SharedFacade,
  customDecode,
  customEncode,
  decrypt,
  encrypt,
} from '@piqet-angular/data';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { ColDef } from 'ag-grid-community';
import { GridIconComponent } from 'libs/ui/src/lib/grid-icon/grid-icon.component';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ViewportScroller } from '@angular/common';
import { Subscription, catchError, finalize, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AccessPermissionService, CustomModalService } from '@piqet-angular/shared';
@Component({
  selector: 'piqet-angular-project-scenario-wholesale-data',
  templateUrl: './project-scenario-wholesale-data.component.html',
  styleUrls: ['./project-scenario-wholesale-data.component.scss'],
})
export class ProjectScenarioWholesaleDataComponent {
  checkboxValue = false;
  columnDefs!: ColDef[];
  projectScenarioWholesalePayload: any;
  activatedRoute: any;
  activatedRouteProjectId: any;
  scenarioId: any;
  eId: any;
  isScreenDisabled: any;
  navigationConfig: any;
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  searchData: any = '';
  sortColumnState: any;
  someSubscription: any;
  gridName: string = 'Project scenario wholesale list';
  event: any;
  headerData = {
    materialName: 'Wholesale',
  };
  nextRoute: any;
  menuDataForRouting: any;
  packageScenarioId: any;
  isHideSideBar = false;
  wholesaleList: any;
  deleteWholesale: Subscription;
  editWholesaleSuccess: Subscription;
  subscriptionInline: Subscription;
  backRouteType: any;
  showEdit: boolean = false;
  constructor(
    private projectScenarioWholesaleDataGridService: ProjectScenarioWholesaleDataGridService,
    private projectService: ProjectsService,
    private viewportScroller: ViewportScroller,
    public projectFacade: ProjectsFacade,
    public route: ActivatedRoute,
    private router: Router,
    public sharedFacade: SharedFacade,
    private sharedService: SharedService,
    private toaster: ToastrService,
    private modal: CustomModalService,
    private accessService: AccessPermissionService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    const url = location.href.split('/');
    let urlEqual = this.router.url.lastIndexOf('=');
    this.scenarioId = this.router.url.slice(urlEqual + 1);
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
      this.eId = value['eId'];
      this.getWholesaleList();
    });

    this.sharedService.menuData$.subscribe((res: any) => {
      this.menuDataForRouting = res;
    });

    this.columnDefs = this.projectScenarioWholesaleDataGridService.projectScenarioWholesaleData();
    this.projectScenarioWholesalePayload = this.projectScenarioWholesaleDataGridService.getPayload(
      this.searchData
    );

    this.deleteWholesale =
      this.projectScenarioWholesaleDataGridService.deleteWholesaleData$.subscribe(
        async deleteData => {
          this.deleteWholesaleData(deleteData[0]);
        }
      );

    this.editWholesaleSuccess =
      this.projectScenarioWholesaleDataGridService.editWholesaleSuccessData$.subscribe(
        async data => {
          this.getWholesaleList();
        }
      );

    this.subscriptionInline =
      this.projectScenarioWholesaleDataGridService.inlineEditingObservable$.subscribe(
        (inlineData: any) => {
          this.inlineDataEditing(inlineData);
        }
      );
  }

  ngOnInit(): void {
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute, 'packaging');
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  inlineDataEditing(payload: any) {
    this.projectService
      .projectRetailAndConsumerInlineEdit(payload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getWholesaleList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  async getWholesaleList() {
    const wholesaleList = (
      await this.projectService.getMyAllProjectScenarioWholesaleListAsync(
        1,
        this.packageScenarioId,
        this.activatedRouteProjectId
      )
    ).data;

    wholesaleList?.storageList.map((item: any) => {
      item.storageTransportDetail.map((data: any) => {
        data['cityName'] = data.originName;
      });
    });
    this.wholesaleList = wholesaleList;
    this.checkboxValue = this.wholesaleList?.isExcludeWholesale;
    this.isScreenDisabled = this.wholesaleList?.isLockProject;
    this.navigationConfig = {
      scenarioId: this.scenarioId,
      packageScenarioId: this.packageScenarioId,
      eId: this.eId,
      activatedRouteProjectId: this.activatedRouteProjectId,
      activatedRoute: this.activatedRoute,
      isProjectLocked: this.isScreenDisabled,
      isProductPage: true,
    };
  }

  deleteWholesaleData(data: any) {
    this.projectService
      .deleteProjectWholesale(data.id)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getWholesaleList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  addWholesaleData(data: any) {
    this.projectService
      .addUpdateProjectWholesale(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.getWholesaleList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  onCheckboxChange(eve: any) {
    this.checkboxValue = eve.target.checked ? true : false;
    this.projectService.disableWholesale(this.checkboxValue, this.packageScenarioId).subscribe();
  }

  async addWholesale(scenarioId: any, id: any, storageTypeId: any, label: any) {
    let response = await this.projectService.getProjectWholesaleAddUpdateAsync(
      scenarioId,
      id,
      storageTypeId
    );
    this.modal.invoke('newAddProjectScenarioWholesale', {
      initialState: {
        wholesaleData: response.data,
        label: label,
        scenarioId: response.scenarioId,
        projectId: response.projectId,
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveNewMyProjectWholesaleEvent.subscribe(
      (saveNewMyProjectWholesaleEvent: any) => {
        this.addWholesaleData(saveNewMyProjectWholesaleEvent);
      }
    );
  }

  editRecord(record: any) {}

  ngOnDestroy() {
    this.deleteWholesale.unsubscribe();
    this.editWholesaleSuccess.unsubscribe();
    this.subscriptionInline.unsubscribe();
  }
}
